import { Link } from '@remix-run/react';
import { ChildPage } from './page-packages';
import { FormattedString, useMessages } from '../i18n/useMessages';

export function ChildPagePreview({
  path,
  readingTime,
  title,
  summary,
  heroImage,
}: ChildPage) {
  const getMessage = useMessages();

  return (
    <article className="group h-full">
      <Link prefetch="intent" to={path} className="block h-full">
        <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-red-200 h-full flex flex-col">
          {heroImage && (
            <div className="relative h-44 overflow-hidden">
              <img
                src={heroImage}
                alt={getMessage(title)}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              {readingTime ? (
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-red-200 text-white text-xs font-medium uppercase tracking-wider rounded-full">
                    {readingTime} min read
                  </span>
                </div>
              ) : null}
            </div>
          )}
          <div className="p-5 flex flex-col flex-1">
            <h3 className="font-serif text-gray-900 group-hover:text-red-200 text-lg font-bold transition-colors">
              <FormattedString message={title} />
            </h3>
            {summary && (
              <p className="mt-2 text-gray-600 text-sm line-clamp-2 flex-1">{summary}</p>
            )}
            <div className="mt-4 pt-3 border-t border-gray-100 flex items-center justify-between">
              {!heroImage && readingTime ? (
                <span className="text-xs text-gray-500 uppercase tracking-wider">
                  {readingTime}{' '}
                  <FormattedString message="camp67-content-page.child.reading-time" />
                </span>
              ) : (
                <span />
              )}
              <span className="text-red-200 font-semibold text-sm group-hover:translate-x-1 transition-transform">
                Read &rarr;
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}
